import { render, staticRenderFns } from "./filter-list.vue?vue&type=template&id=55ab67c8&scoped=true&lang=pug&"
import script from "./filter-list.vue?vue&type=script&lang=ts&"
export * from "./filter-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab67c8",
  null
  
)

export default component.exports